import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-charts-dashboard',
  templateUrl: './customer-charts-dashboard.component.html',
  styleUrls: ['./customer-charts-dashboard.component.scss']
})
export class CustomerChartsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
